import script from "./TransactCustomerDistribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactCustomerDistribution.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__